
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("bq09U", function(module, exports) {

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $9dp5m = parcelRequire("9dp5m");

var $2bkbY = parcelRequire("2bkbY");

var $5BRby = parcelRequire("5BRby");

var $2apnq = parcelRequire("2apnq");

var $49235 = parcelRequire("49235");

var $geFaw = parcelRequire("geFaw");

var $gd0Sp = parcelRequire("gd0Sp");
(0, $2apnq.provideHealthcheck)();
const $a4ee35ebee2548a7$var$container = document.createElement('div');
$a4ee35ebee2548a7$var$container.id = 'heartbeat';
document.body && document.body.appendChild($a4ee35ebee2548a7$var$container);
const $a4ee35ebee2548a7$var$redirect = ()=>{
    const identity = (0, $9dp5m.getATLContextDomain)('id');
    const redirectUrl = `https://${identity}/login?application=jira&continue=${encodeURIComponent(window.location.href)}`;
    window.location.assign(redirectUrl);
};
(0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geFaw.StrictMode), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $49235.JiraContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: { isAnonymous: isAnonymous } })=>!isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
        id: "heartbeat"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2bkbY.default), {
        onAuthenticationFailed: $a4ee35ebee2548a7$var$redirect
    }))))), $a4ee35ebee2548a7$var$container);

});
parcelRegister("2bkbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $196c459163a7d18c$export$2e2bcd8739ae039);


var $jki6I = parcelRequire("jki6I");
const $196c459163a7d18c$var$Heartbeat = ({ endpoint: endpoint = (0, $dba2e996a2e3cb59$export$4496080a0271e85d), idleTime: idleTime = (0, $dba2e996a2e3cb59$export$af2ff676951003fe), onAuthenticationFailed: onAuthenticationFailed, onBadRequest: onBadRequest })=>{
    (0, $jki6I.useHeartbeatOnInterval)(endpoint, idleTime, onAuthenticationFailed, onBadRequest);
    return null;
};
var $196c459163a7d18c$export$2e2bcd8739ae039 = $196c459163a7d18c$var$Heartbeat;

});
const $dba2e996a2e3cb59$export$4496080a0271e85d = '/gateway/api/session/heartbeat';
const $dba2e996a2e3cb59$export$af2ff676951003fe = 60000;
const $dba2e996a2e3cb59$export$f2b2f5ef0b498d26 = 10000;

parcelRegister("jki6I", function(module, exports) {

$parcel$export(module.exports, "useHeartbeatOnInterval", () => $e11dee56109d09e1$export$27f64c06d2059d33);

var $eUqFw = parcelRequire("eUqFw");

var $lu9mt = parcelRequire("lu9mt");


var $edKws = parcelRequire("edKws");

var $6cAOU = parcelRequire("6cAOU");
const $e11dee56109d09e1$export$27f64c06d2059d33 = (endpoint, idleTime, onAuthenticationFailed, onBadRequest)=>{
    const { nextCallTimestamp: nextCallTimestamp, sessionExpiryTimestamp: sessionExpiryTimestamp, callHeartbeatService: callHeartbeatService, setCallHeartbeatService: setCallHeartbeatService, deactivated: deactivated } = (0, $6cAOU.useHearbeatService)(endpoint, onAuthenticationFailed, onBadRequest);
    const { active: active, tabActive: tabActive } = (0, $edKws.useBrowserInteractionTime)(idleTime);
    /**
   * Initial heartbeat api request
   */ (0, $eUqFw.useEffect)(()=>{
        setCallHeartbeatService(true); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * Call heartbeat api when user is idle and the tab is active
   */ (0, $eUqFw.useEffect)(()=>{
        if (!active && tabActive) setCallHeartbeatService(true);
    }, [
        active,
        tabActive,
        setCallHeartbeatService
    ]);
    (0, $lu9mt.default)(()=>{
        if (callHeartbeatService) return;
        /**
     * Call heartbeat api when session has expired to initiate redirect.
     */ if (sessionExpiryTimestamp && sessionExpiryTimestamp.getTime() <= Date.now()) {
            setCallHeartbeatService(true);
            return;
        }
        /**
     * Call heartbeat api if user is active and nextCallTimestamp is reached.
     */ if (active && tabActive && nextCallTimestamp && nextCallTimestamp.getTime() <= Date.now()) setCallHeartbeatService(true);
    }, (0, $dba2e996a2e3cb59$export$f2b2f5ef0b498d26));
    return {
        nextCallTimestamp: nextCallTimestamp,
        sessionExpiryTimestamp: sessionExpiryTimestamp,
        active: active,
        tabActive: tabActive,
        deactivated: deactivated
    };
};

});
parcelRegister("lu9mt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa43a9552c1c752d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $fa43a9552c1c752d$var$useInterval = function useInterval(callback, delay) {
    var savedCallbackRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(function() {
        savedCallbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $eUqFw.useEffect)(function() {
        var handler = function handler() {
            return savedCallbackRef.current.apply(savedCallbackRef, arguments);
        };
        if (delay !== null) {
            var intervalId = setInterval(handler, delay);
            return function() {
                return clearInterval(intervalId);
            };
        }
    }, [
        delay
    ]);
};
var $fa43a9552c1c752d$export$2e2bcd8739ae039 = $fa43a9552c1c752d$var$useInterval;

});

parcelRegister("edKws", function(module, exports) {

$parcel$export(module.exports, "useBrowserInteractionTime", () => $a5a65dfc94730c7b$export$430908eb26d619ec);

var $eUqFw = parcelRequire("eUqFw");

var $cJt2B = parcelRequire("cJt2B");
const $a5a65dfc94730c7b$export$430908eb26d619ec = (threshold)=>{
    const [active, setActive] = (0, $eUqFw.useState)(true);
    const [tabActive, setTabActive] = (0, $eUqFw.useState)(true);
    const activeRef = (0, $eUqFw.useRef)(active);
    activeRef.current = active;
    (0, $eUqFw.useEffect)(()=>{
        let timer;
        timer = new (0, $cJt2B.default)({
            idleTimeoutMs: threshold,
            stopTimerOnTabchange: false,
            browserTabActiveCallbacks: [
                ()=>{
                    setTabActive(true);
                }
            ],
            browserTabInactiveCallbacks: [
                ()=>{
                    setTabActive(false);
                }
            ],
            idleCallbacks: [
                ()=>{
                    if (activeRef.current) setActive(false);
                }
            ],
            activeCallbacks: [
                ()=>{
                    if (!activeRef.current) setActive(true);
                }
            ]
        });
        timer.startTimer();
        return ()=>{
            timer && timer.destroy();
            timer = null;
        };
    }, [
        threshold
    ]);
    return {
        active: active,
        tabActive: tabActive
    };
};

});

parcelRegister("6cAOU", function(module, exports) {

$parcel$export(module.exports, "useHearbeatService", () => $48406ccb412b5267$export$5cc515bf8ee32bda);

var $eUqFw = parcelRequire("eUqFw");

var $aUi9p = parcelRequire("aUi9p");
const $48406ccb412b5267$export$5cc515bf8ee32bda = (endpoint, onAuthenticationFailed, onBadRequest)=>{
    const [nextCallTimestamp, setNextCallTimestamp] = (0, $eUqFw.useState)(undefined);
    const [sessionExpiryTimestamp, setSessionExpiryTimestamp] = (0, $eUqFw.useState)(undefined);
    const [callHeartbeatService, setCallHeartbeatService] = (0, $eUqFw.useState)(false);
    const [deactivated, setDeactivated] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (callHeartbeatService && endpoint && !deactivated) {
            const callAsync = async ()=>{
                try {
                    const response = await (0, $aUi9p.postHeartbeat)(endpoint, onAuthenticationFailed, onBadRequest);
                    setCallHeartbeatService(false);
                    if (response && response.nextCallTimestamp) setNextCallTimestamp(new Date(response.nextCallTimestamp));
                    if (response && response.sessionExpiryTime) setSessionExpiryTimestamp(new Date(response.sessionExpiryTime));
                } catch (error) {
                    setDeactivated(true);
                }
            };
            callAsync();
        }
    }, [
        callHeartbeatService,
        endpoint,
        onAuthenticationFailed,
        onBadRequest,
        deactivated
    ]);
    return {
        nextCallTimestamp: nextCallTimestamp,
        sessionExpiryTimestamp: sessionExpiryTimestamp,
        callHeartbeatService: callHeartbeatService,
        setCallHeartbeatService: setCallHeartbeatService,
        deactivated: deactivated
    };
};

});
parcelRegister("aUi9p", function(module, exports) {

$parcel$export(module.exports, "postHeartbeat", () => $7f0d36b2c5bfd96c$export$931f43089f67754c);
const $7f0d36b2c5bfd96c$var$RETRY_HTTP_CODES = [
    408,
    500,
    502,
    503,
    504,
    522,
    524
];
function $7f0d36b2c5bfd96c$var$timeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
async function $7f0d36b2c5bfd96c$var$fetchRetry(url, options = {}, retries = 5, backoff = 300) {
    const response = await fetch(url, options);
    if (response.ok || response.status === 401) return response;
    if (retries > 0 && $7f0d36b2c5bfd96c$var$RETRY_HTTP_CODES.includes(response.status)) {
        await $7f0d36b2c5bfd96c$var$timeout(backoff);
        return await $7f0d36b2c5bfd96c$var$fetchRetry(url, options, retries - 1, backoff * 2);
    } else return Promise.reject(response);
}
const $7f0d36b2c5bfd96c$export$931f43089f67754c = async (endpoint, onAuthenticationFailed, onBadRequest)=>{
    try {
        const response = await $7f0d36b2c5bfd96c$var$fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (response && response.ok) return response.json();
        if (response && response.status === 401 && onAuthenticationFailed) {
            onAuthenticationFailed();
            return;
        }
    } catch (e) {
        const errorResponse = e;
        if (errorResponse.status === 400) {
            onBadRequest === null || onBadRequest === void 0 || onBadRequest();
            return Promise.reject(errorResponse);
        }
        if ($7f0d36b2c5bfd96c$var$RETRY_HTTP_CODES.includes(errorResponse.status)) console.warn('Heartbeat: Retried 5x, stopped to call api');
    }
};

});




parcelRegister("2apnq", function(module, exports) {

$parcel$export(module.exports, "provideHealthcheck", () => $2d3550a09830cc5e$export$90dcee7ddb8a0c0c);

var $1ybV0 = parcelRequire("1ybV0");
const $2d3550a09830cc5e$var$globalObj = window || $parcel$global;
const $2d3550a09830cc5e$var$defaultHealthcheck = (callback)=>callback({
        isSuccess: true
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d3550a09830cc5e$var$failingHealthcheck = (callback)=>callback({
        isSuccess: false
    });
const $2d3550a09830cc5e$export$90dcee7ddb8a0c0c = (healthcheck = $2d3550a09830cc5e$var$defaultHealthcheck)=>{
    const isHealthcheckAllFailEnabled = (0, $1ybV0.ff)('fe.platform.healthcheck.allfail.enabled');
    if (isHealthcheckAllFailEnabled) {
        $2d3550a09830cc5e$var$globalObj.performHealthcheck = $2d3550a09830cc5e$var$failingHealthcheck;
        return;
    }
    $2d3550a09830cc5e$var$globalObj.performHealthcheck = healthcheck;
};

});



//# sourceMappingURL=async-heartbeat.3fd59ee5.js.map
